import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

// define EVENTs
import "HSNDIR/Widget/FlexPayProcessPayments.js";
import "HSNDIR/Widget/FlexPayPayNow.js";
import "HSNDIR/Widget/FlexPayOrder.js";

/**
* class HSN.FlexPayManagerPayNowModal
*
* Encapsulates the functionality of a modal dialog.
**/
HSN.FlexPayManagerPayNowModal = (function (parent) {
    __extends(FlexPayManagerPayNowModal, parent);

    function FlexPayManagerPayNowModal() {
        /** new HSN.FlexPayManagerPayNowModal() **/
        var modal = FlexPayManagerPayNowModal.__super__.constructor.call(this);

        this.Close.off();//remove existing handler, have our own
        this.accountService = HSN.Instance()._getAccountService();

        this.isProcessingFinished = false;
        eventHandlers(this);
            
        return modal;
    }

    function eventHandlers(modal) {
        $(modal.Close).on('click', function () {
            closeModal(modal, modal.isProcessingFinished);
        });
        HSN.Instance().Events.On(HSN.Widget.FlexPayProcessPayments.EVENT.FINISHED, function() {
            modal.isProcessingFinished = true;
        });
        HSN.Instance().Events.On(HSN.Widget.FlexPayProcessPayments.EVENT.ERROR, function () {
            modal.isProcessingFinished = true;
        });
        HSN.Instance().Events.On(HSN.Widget.FlexPayProcessPayments.EVENT.RETURN_TO_MANAGER, function () {
            closeModal(modal, true);
        });
        HSN.Instance().Events.On(HSN.Widget.FlexPayPayNow.EVENT.CANCELLED, function () {
            closeModal(modal, false);
        });
    }

    function closeModal(modal, doRefresh) {
        modal.Hide();
        if(doRefresh) {
            HSN.Instance().Events.Trigger(HSN.Widget.FlexPayOrder.EVENT.REFRESH, modal.orderIdentity);
        }
    }

    /**
    * HSN.FlexPayManagerPayNowModal#Show() -> void
    * Display the modal and load in the information.
    **/
    FlexPayManagerPayNowModal.prototype._show = function (config) {
        var scope = this;
        scope.orderIdentity = config.orderIdentity;
        scope.paymentNumbers = config.data.flexPayNumbers;
        scope.AddLoadingSpinner();
        $.ajax('/myaccount/flexpay-manager/pay-now/' + config.orderIdentity,
            {
                context: this,
                dataType: 'html',
                data: $.param(config.data, true),
                success: function (content) {
                    scope.RemoveLoadingSpinner();
                    scope.Content.showHtml(
                        content,
                        0,
                        function () {
                            scope.Center();
                            scope.Content.animate({ opacity: 1 });
                            scope.Content.focus();
                        },
                        function () {
                        }
                    );
                },
                error: function () {
                    alert('Unfortunately there was an error attempting to load the content, please try again.');
                    scope.RemoveLoadingSpinner();
                    scope.Hide();
                }
            }
        );
    };
    return FlexPayManagerPayNowModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/Modals/MyAccount/FlexPayManagerPayNowModal.js